// Logs when the client route changes
/* eslint-disable-next-line */
export const onRouteUpdate = ({ location }) => {
    // TODO: track page view
};
